<template>
  <div class="bg-[#f4f3f6] w-full min-h-screen flex flex-col items-center relative">

    <NavBar />

    <div class="absolute inset-0 overflow-hidden ">
      <!-- Blob 1 -->
      <div class="absolute top-10 left-10 w-72 h-72 bg-gifty-pink/30 rounded-full blur-[100px] animate-float-slow"></div>

      <!-- Blob 2 -->
      <div class="absolute top-1/3 right-20 w-80 h-80 bg-gifty-text_blue/30 rounded-full blur-[120px] animate-float-medium">
      </div>

     <div class="absolute bottom-20 left-1/4 w-96 h-96 bg-[#ffadc0]/15 rounded-full blur-[150px] animate-float-fast"> </div>

      <!-- Blob 4 -->
      <div
        class="absolute bottom-0 right-0 w-[30rem] h-[30rem] bg-gifty-pink_dark/10 rounded-full blur-[180px] animate-float-slow">
      </div>
    </div>

    <div class=" flex-1 flex justify-center items-center w-full relative" :dir="direction">

      <transition name="fade" mode="out-in">
        <GoogleMapsModal v-if="showLocationModal" @toggleOff="toggleLocationModal(false)" />
      </transition>

      <!-- <transition name="fade" mode="out-in">
        <LocationModal v-if="showLocationModal" @toggleOff="toggleLocationModal(false)" :component="modal.component" />
      </transition> -->


      <transition name="fade" mode="out-in">
        <MessageModal v-if="modal.show" :success="modal.success" :message="modal.message"
          :component="modal.component" />
      </transition>

      <transition name="fade" mode="out-in">
        <Loading_modal v-if="loading"></Loading_modal>

      </transition>
      <transition name="fade" mode="out-in">
        <router-view @toggleLoading="toggleLoading" @toggleMessageModal="toggleMessageModal"
          @toggleLocationModal="toggleLocationModal(true)" />
      </transition>
    </div>

  </div>
</template>

<script setup>
import NavBar from './components/navBar.vue';

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import Loading_modal from './components/loading_modal.vue';
import MessageModal from './components/messageModal.vue';
// import LocationModal from './components/locationModal.vue';
import GoogleMapsModal from './components/googleMapsModal.vue';
import { useRegistrationStore } from './stores/registrationStore';



const { locale } = useI18n()
const direction = computed(() => (locale.value === 'fr' ? 'ltr' : 'rtl'))

const loading = ref(false)

const toggleLoading = (show) => {
  loading.value = show;
}


const modal = ref({
  show: false,
  success: false,
  message: "",
  component: ""
})
const toggleMessageModal = (show, success, message, component) => {
  modal.value.show = show;
  modal.value.success = success;
  modal.value.message = message;
  modal.value.component = component;

  setTimeout(() => {

    modal.value.show = false;
    modal.value.success = null;
    modal.value.message = "";
    modal.value.component = "";

  }, 2000);
}

const registerStore = useRegistrationStore();
const showLocationModal = ref(false);
const toggleLocationModal = async (show = true) => {
  if (show) {
    try {

      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
        });
      });

      const { latitude, longitude } = position.coords;


      registerStore.registration.geolocation = { latitude, longitude };

      console.log("✅ User location:", latitude, longitude);
    } catch (err) {
      console.warn("⚠️ Could not get location:", err.message);

      registerStore.registration.geolocation = {
        latitude: 36.7627,
        longitude: 3.0574,
      };
    }
  }

  // Finally toggle modal
  showLocationModal.value = show;
};

</script>

<style>
/* now everything works normally, no :global needed */
@keyframes float-slow {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.9;
  }

  50% {
    transform: translate(30px, -30px) scale(1.05);
    opacity: 1;
  }
}

@keyframes float-medium {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }

  50% {
    transform: translate(-40px, 40px) scale(1.08);
    opacity: 1;
  }
}

@keyframes float-fast {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.8;
  }

  50% {
    transform: translate(50px, -20px) scale(1.03);
    opacity: 0.95;
  }
}

.animate-float-slow {
  animation: float-slow 3s ease-in-out infinite;
}

.animate-float-medium {
  animation: float-medium 2s ease-in-out infinite;
}

.animate-float-fast {
  animation: float-fast 1s ease-in-out infinite;
}

/* keep your fade transition too */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(50px);
}

.fade-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>
